import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router";
import RoutesWrapper from "@components/common/routing/RoutesWrapper";
import { SecurityProvider } from "@components/common/security/SecurityProvider";

function App() {
  const queryClient = new QueryClient();

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SecurityProvider>
          <BrowserRouter>
            <RoutesWrapper />
          </BrowserRouter>
        </SecurityProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
